export default function PromoTag({ apiTag, promoTypes }) {
  let tagName = apiTag;
  let icon = 'question_mark';

  const promoType = promoTypes.find(t => t.api_name === apiTag);

  if (promoType) {
    tagName = promoType.name;
    icon = promoType.material_icon;
  }

  return (
    <div className="tag badge label-2 d-inline-flex align-items-center bg-light text-info">
      <span className="material-icons fs-5 me-1">{icon}</span>
      {tagName}
    </div>
  );
}